export const getMessageDetailsThemeColors = (isDarkMode) => ({
    cardBackground: isDarkMode ? '#1f1f1f' : '#fff',
    text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
    secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.65)' : 'rgba(0, 0, 0, 0.45)',
});

export const getDangerTitleColor = (isDarkMode) => (
    isDarkMode ? 'orange' : '#ff4d4f'
);
